import React, { Component } from 'react';
import * as UiConsts from '../../../../config/UiConstants';
import { firebaseAuth, toCurrency, pythonApiIp, logComponentLoad, logDashboardAction, serverIp } from '../../../../config/constants.js'
import axios from 'axios'
import { Button, Image, Header, Divider, Form } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { checkAdminEmail, getPrintValues, } from '../algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';
import ImageUploader from '../../../newSite/ImageUploader'

import { getShirtTypesToDisplay } from '../LargeProjects/ApiUtils'



import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });



class ViewRequisition_dynamic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sentRequisition: '',
            loading: false,
            algoliaUser: '',
            dailyExpenseOptions: [],
            dailyExpense: '',
            deduct_awori_log_choices: [
                { value: 'yes', label: 'yes', category: 'deduct_awori_log' },
                { value: 'no', label: 'no', category: 'deduct_awori_log' },
            ],
            fromWhere: '',
            fromWhereOptions: [],
        }
    }


    componentDidMount() {
        console.log("vidx1 ++++++ componentDidMount ");

        console.log("vidx algoliaUser:" + JSON.stringify(this.props.algoliaUser, null, 3));
        console.log("vidx ++++++++++++++++")
        console.log("vidx: reqId" + this.props.reqId);
        console.log("vidx ++++++++++++++++")
        console.log("vidx1: user:" + JSON.stringify(this.props.user, null, 3));

        if (this.props.algoliaUser == undefined) {
            alert("AG USER IS UNDEFINED");

        } else if (this.props.reqId == undefined) {
            alert("reqId IS UNDEFINED");

        } else if (this.props.user == undefined) {
            alert("user IS UNDEFINED");

        } else {
            // logComponentLoad(returnObject, "ViewRequisition");
            this.setState({
                algoliaUser: this.props.algoliaUser,
                //isAdmin: returnObject.isAdmin,
            })

            if (this.props.algoliaUser.perms && this.props.algoliaUser.perms.includes("payRequisition") && this.props.reqId) {
                console.log("getrx2 his.props.match.params.reqId exists:" + this.props.reqId)
                this.getRequisition(this.props.reqId);
                getPrintValues("requisition", this.loadOptions);
                getPrintValues("fromWhere", this.fromWhere);

                getShirtTypesToDisplay(this.setShirtTypeDropDown, "dailyExpense_ivan");
            }
        }



    }


    setShirtTypeDropDown = (shirtTypes) => {
        console.log("gshtx21 +++++++:setShirtTypeDropDown");
        // console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            dailyExpenseOptions: shirtTypes
        })

    }

    fromWhere = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ fromWhereOptions: statuses })
    }

    loadOptions = (displayTypes) => {
        console.log("shtx18 ++++++ load display Types ");
        console.log("shtx18 displayTypes:" + JSON.stringify(displayTypes, null, 3));
        this.setState({ sendToOptions: displayTypes })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    getRequisition = () => {
        console.log("getRx12 ++++++ getRequisition ");

        this.setState({ loading: true });

        axios.post(serverIp + 'billing/getRequisition', {
            apiKey: "getRequisition",
            requisitionId: this.props.reqId,
            enteredBy: this.props.user.email
        })
            .then((response) => {
                console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    this.setState({
                        sentRequisition: response.data.requisition,
                    });

                    logDashboardAction(this.props.user.email + " viewed requisition " + this.props.reqId, this.props.user.email, null, "ViewRequisition_dynamic");
                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                this.setState({ loading: false });
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    payRequisition = () => {
        console.log("getRx12 ++++++ payRequisition ");

        this.setState({ loading: true });

        axios.post(serverIp + 'billing/payRequisition', {
            apiKey: "payRequisition",
            requisitionId: this.props.reqId,
            enteredBy: this.props.user.email,
            sentTo: this.state.requisition,
            imageUrl: this.state.imageUrl,
            deduct_awori_log: 'yes',
            fromWhere: this.state.fromWhere,
            shirtTypeId: this.state.shirtTypeId,
            sentNotes: this.state.sentNotes
        })
            .then((response) => {
                console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {

                    this.setState({
                        sentRequisition: response.data.requisition,
                    });

                    logDashboardAction(this.props.user.email + " paid requisition " + this.props.reqId, this.props.user.email, null, "payRequisition");

                    this.props.clearFeilds();
                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                this.setState({ loading: false });
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++:updateWhenFileUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url,
            sendImage: true
        });
        // this.props.history.push('/newOrder/thankYou');

    }

    clearFeilds = () => {
        this.setState({

        })
    }


    render() {

        const imagePreview = this.state.imageUrl != ''
            ? (<Image src={this.state.imageUrl} fluid />)
            : (<p></p>)

        const payImage = this.state.sentRequisition != '' && this.state.sentRequisition.sentImage
            ? (<Image src={this.state.sentRequisition.sentImage} />)
            : (<p></p>)

        const payReq = this.props.algoliaUser
            && this.props.algoliaUser != ''
            && this.props.algoliaUser.perms
            && this.props.algoliaUser.perms.includes("payRequisition")
            && this.state.sentRequisition != ''
            && this.state.sentRequisition.paid === 'no'
            ? <div>
                <Divider horizontal>{'STEP PAY REQUISITION'}</Divider>
                <Select
                    name="form-field-name"
                    value={this.state.requisition}
                    options={this.state.sendToOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />

                <br />
                {/* <label>Deduct Awori Log?</label>
                <Select
                    name="form-field-name"
                    value={this.state.deduct_awori_log}
                    options={this.state.deduct_awori_log_choices}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                <br /> */}

                <label> WHAT IS THE CAUSE OF THIS PAYMENT </label>
                <Select
                    name="form-field-name"
                    value={this.state.fromWhere}
                    options={this.state.fromWhereOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />

                <label>Expense {this.state.newDailyExpense} </label>
                <Select
                    name="form-field-name"
                    value={this.state.shirtTypeId}
                    options={this.state.dailyExpenseOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />

                {/* sent notes */}
                <Form.Field>
                    <label>Notes</label>
                    <Form.Input
                        fluid
                        name={'sentNotes'}
                        value={this.state.sentNotes}
                        icon='add user'
                        iconPosition='left'
                        placeholder='sentNotes'
                        onChange={this.handleTextInputChange}
                        type='text' />
                </Form.Field>

                <Button color='green' fluid onClick={this.payRequisition}> PAY</Button>
                <br />
                <ImageUploader
                    updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                    storageReference={'requisitions'} />

                <br />
                {imagePreview}
            </div>
            : ''

        const wholeUI = this.props.algoliaUser
            && this.props.algoliaUser != ''
            && this.props.algoliaUser.perms
            && this.props.algoliaUser.perms.includes("payRequisition")
            // && this.state.sentRequisition != ''
            ? <div>


                <Divider horizontal>{'PAY REQ #'+this.state.sentRequisition.idrequisition}</Divider>
                <h3> REQUISITION INFO FOR #{this.state.sentRequisition.idrequisition}</h3>
                <h2> {this.state.sentRequisition.notes}</h2>

                <Header as='h2' color='brown'>
                    {this.state.sentRequisition.idrequisition}
                    <Header.Subheader>
                        Req id
                </Header.Subheader>
                </Header>

                <Header as='h2' color='red'>
                    {this.state.sentRequisition.paid}
                    <Header.Subheader>
                        PAID
                </Header.Subheader>
                </Header>

                <Header as='h4' color='teal'>
                    {this.state.sentRequisition.dateRequested}
                    <Header.Subheader>
                        Date Required
                </Header.Subheader>
                </Header>

                <Header as='h3' color='green'>
                    {toCurrency(this.state.sentRequisition.amount)}
                    <Header.Subheader>
                        Amount
                </Header.Subheader>
                </Header>

                <Header as='h3' color='red'>
                    {this.state.sentRequisition.notes}
                    <Header.Subheader>
                        Notes
                </Header.Subheader>
                </Header>

                <Header as='h3' color='red'>
                    {this.state.sentRequisition.reqBy}
                    <Header.Subheader>
                        Req By
                </Header.Subheader>
                </Header>

                {payReq}
                {payImage}
            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>
                {wholeUI}
            </div>);
    }
}

export default ViewRequisition_dynamic;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Requisition/ViewRequisition_dynamic.js